'use strict';

// var base = require('base/product/base');
var lyonscg = require('lyonscg/product/base');
var imagesloaded = require('imagesloaded');
var slickConfigs = require('../config/slickConfigs');
var carousels = require('../components/carousels');

/**
 * Process the attribute values for an attribute that has image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 * @param {Object} msgs - object containing resource messages
 */
function processSwatchValues(attr, $productContainer, msgs) {
    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer.find('[data-attr="' + attr.id + '"] [data-attr-value="' +
            attrValue.value + '"]');
        var $swatchButton = $attrValue.parent();
        var newBadgeAttr = $productContainer.find('[data-newbadge-swatchcolor="' + attrValue.value + '"]');
        if (attrValue.selected) {
            $attrValue.addClass('selected');
            $attrValue.siblings('.selected-assistive-text').text(msgs.assistiveSelectedText);
        } else {
            $attrValue.removeClass('selected');
            $attrValue.siblings('.selected-assistive-text').empty();
        }

        if ($('.attribute .color-attribute .color-value.selected')) {
            var selectedColor = $('.attribute .color-attribute .color-value.selected').attr('data-attr-value');
            $('.attributes .color.non-input-label .selected-color').attr('aria-label', 'Selected Color ' + selectedColor);
            $('.attributes .color.non-input-label .selected-color').text(selectedColor);
        }

        if (attrValue.url) {
            $swatchButton.attr('data-url', attrValue.url);
        } else {
            $swatchButton.attr('data-url', attrValue.baseUrl);
        }

        // Disable if not selectable
        $attrValue.removeClass('selectable unselectable');
        $attrValue.addClass(attrValue.selectable ? 'selectable' : 'unselectable');
        if (newBadgeAttr.length > 0 && !attrValue.selectable) {
            newBadgeAttr.addClass('d-none');
        } else if (newBadgeAttr.length > 0 && attrValue.selectable && attrValue.isNew) {
            if (newBadgeAttr.hasClass('d-none')) {
                newBadgeAttr.removeClass('d-none');
            }
        } else if (newBadgeAttr.length === 0 && attrValue.selectable && attrValue.isNew) {
            $attrValue.html('<div class="new-badge" data-newbadge-swatchcolor="' + attrValue.value + '">NEW</div>');
        }
    });
}

/**
 * Process attribute values associated with an attribute that does not have image swatches
 *
 * @param {Object} attr - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {Object[]} attr.values - Array of attribute value objects
 * @param {string} attr.values.value - Attribute coded value
 * @param {string} attr.values.url - URL to de/select an attribute value of the product
 * @param {boolean} attr.values.isSelectable - Flag as to whether an attribute value can be
 *     selected.  If there is no variant that corresponds to a specific combination of attribute
 *     values, an attribute may be disabled in the Product Detail Page
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function processNonSwatchValues(attr, $productContainer) {
    var $attr = '[data-attr="' + attr.id + '"]';
    var $defaultOption = $productContainer.find($attr + ' .select-' + attr.id + ' option:first');
    $defaultOption.attr('value', attr.resetUrl);

    attr.values.forEach(function (attrValue) {
        var $attrValue = $productContainer
            .find($attr + ' [data-attr-value="' + attrValue.value + '"]');
        $attrValue.attr('value', attrValue.baseUrl)
            .removeAttr('disabled');
        $attrValue.parent().removeClass('unselectable');
        var $parentButton = $attrValue.parent('button');

        if (attrValue.selectable) {
            $attrValue.removeAttr('disabled');
            $parentButton.addClass('selectable');
            $parentButton.removeClass('unselectable');
        } else {
            $attrValue.attr('disabled', true);
            $parentButton.removeClass('selectable');
            $parentButton.addClass('unselectable');
        }

        // if (attrValue.selected) {
        //     $parentButton.addClass('selected');
        // } else {
        //     $parentButton.removeClass('selected');
        // }
    });
}

/**
 * Routes the handling of attribute processing depending on whether the attribute has image
 *     swatches or not
 *
 * @param {Object} attrs - Attribute
 * @param {string} attr.id - Attribute ID
 * @param {jQuery} $productContainer - DOM element for a given product
 * @param {Object} msgs - object containing resource messages
 */
function updateAttrs(attrs, $productContainer, msgs) {
    // Currently, the only attribute type that has image swatches is Color.
    var attrsWithSwatches = ['color'];

    attrs.forEach(function (attr) {
        if (attrsWithSwatches.indexOf(attr.id) > -1) {
            processSwatchValues(attr, $productContainer, msgs);
        } else {
            processNonSwatchValues(attr, $productContainer);
        }
    });
}

/**
 * Generates html for product attributes section
 *
 * @param {array} attributes - list of attributes
 * @return {string} - Compiled HTML
 */
function getAttributesHtml(attributes) {
    if (!attributes) {
        return '';
    }

    var html = '';

    attributes.forEach(function (attributeGroup) {
        if (attributeGroup.ID === 'mainAttributes') {
            attributeGroup.attributes.forEach(function (attribute) {
                html += '<div class="attribute-values">' + attribute.label + ': '
                    + attribute.value + '</div>';
            });
        }
    });

    return html;
}

/**
 * Dynamically creates Bootstrap carousel from response containing images
 * @param {Object[]} imgs - Array of large product images,along with related information
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function createCarousel(imgs, $productContainer) {
    var carousel = $productContainer.find('.carousel');
    $(carousel).carousel('dispose');
    var carouselId = $(carousel).attr('id');
    $(carousel).empty().append('<ol class="carousel-indicators"></ol><div class="carousel-inner" role="listbox"></div><a class="carousel-control-prev" href="#' + carouselId + '" role="button" data-slide="prev"><span class="fa icon-prev" aria-hidden="true"></span><span class="sr-only">' + $(carousel).data('prev') + '</span></a><a class="carousel-control-next" href="#' + carouselId + '" role="button" data-slide="next"><span class="fa icon-next" aria-hidden="true"></span><span class="sr-only">' + $(carousel).data('next') + '</span></a>');
    for (var i = 0; i < imgs.length; i++) {
        $('<div class="carousel-item"><img src="' + imgs[i].url + '" class="d-block img-fluid" alt="' + imgs[i].alt + ' image number ' + parseInt(imgs[i].index, 10) + '" title="' + imgs[i].title + '" itemprop="image" /></div>').appendTo($(carousel).find('.carousel-inner'));
        $('<li data-target="#' + carouselId + '" data-slide-to="' + i + '" class=""></li>').appendTo($(carousel).find('.carousel-indicators'));
    }
    $($(carousel).find('.carousel-item')).first().addClass('active');
    $($(carousel).find('.carousel-indicators > li')).first().addClass('active');
    if (imgs.length === 1) {
        $($(carousel).find('.carousel-indicators, a[class^="carousel-control-"]')).detach();
    }
    $(carousel).carousel();
    $($(carousel).find('.carousel-indicators')).attr('aria-hidden', true);
}

/**
 * Updates the availability status in the Product Detail Page
 *
 * @param {Object} response - Ajax response object after an
 *                            attribute value has been [de]selected
 * @param {jQuery} $productContainer - DOM element for a given product
 */
function updateAvailability(response, $productContainer) {
    var availabilityValue = '';
    var availabilityMessages = response.product.availability.messages;
    if (!response.product.readyToOrder) {
        availabilityValue = '<li><div>' + response.resources.info_selectforstock + '</div></li>';
    } else {
        availabilityMessages.forEach(function (message) {
            availabilityValue += '<li><div>' + message + '</div></li>';
        });
    }

    $($productContainer).trigger('product:updateAvailability', {
        product: response.product,
        $productContainer: $productContainer,
        message: availabilityValue,
        resources: response.resources
    });
}

/**
 * Parses JSON from Ajax call made whenever an attribute value is [de]selected
 * @param {Object} response - response from Ajax call
 * @param {Object} response.product - Product object
 * @param {string} response.product.id - Product ID
 * @param {Object[]} response.product.variationAttributes - Product attributes
 * @param {Object[]} response.product.images - Product images
 * @param {boolean} response.product.hasRequiredAttrsSelected - Flag as to whether all required
 *     attributes have been selected.  Used partially to
 *     determine whether the Add to Cart button can be enabled
 * @param {jQuery} $productContainer - DOM element for a given product.
 */
function handleVariantResponse(response, $productContainer) {
    var isChoiceOfBonusProducts =
        $productContainer.parents('.choose-bonus-product-dialog').length > 0;
    var isVaraint;
    if (response.product.variationAttributes) {
        updateAttrs(response.product.variationAttributes, $productContainer, response.resources);
        isVaraint = response.product.productType === 'variant';
        if (isChoiceOfBonusProducts && isVaraint) {
            $productContainer.parent('.bonus-product-item')
                .data('pid', response.product.id);

            $productContainer.parent('.bonus-product-item')
                .data('ready-to-order', response.product.readyToOrder);
        }
    }

    // Update primary images
    var primaryImageUrls = response.product.images.large;
    createCarousel(primaryImageUrls, $productContainer);

    // Update pricing
    if (!isChoiceOfBonusProducts) {
        var $priceSelector = $('.prices .price', $productContainer).length
            ? $('.prices .price', $productContainer)
            : $('.prices .price');
        $priceSelector.replaceWith(response.product.price.html);
    }

    // Update promotions
    $productContainer.find('.promotions').empty().html(response.product.promotionsHtml);

    updateAvailability(response, $productContainer);

    if (isChoiceOfBonusProducts) {
        var $selectButton = $productContainer.find('.select-bonus-product');
        $selectButton.trigger('bonusproduct:updateSelectButton', {
            product: response.product, $productContainer: $productContainer
        });
    } else {
        // Enable "Add to Cart" button if all required attributes have been selected
        $('button.add-to-cart, button.add-to-cart-global, button.update-cart-product-global').trigger('product:updateAddToCart', {
            product: response.product, $productContainer: $productContainer
        }).trigger('product:statusUpdate', response.product);
    }

    // Update attributes
    $productContainer.find('.main-attributes').empty()
        .html(getAttributesHtml(response.product.attributes));
}

/**
 * Updates DOM using post-option selection Ajax response
 *
 * @param {OptionSelectionResponse} optionsHtml - Ajax response optionsHtml from selecting a product option
 * @param {jQuery} $productContainer - DOM element for current product
 */
function updateOptions(optionsHtml, $productContainer) {
	// Update options
    $productContainer.find('.product-options').empty().html(optionsHtml);
}

/**
 * Retrieve contextual quantity selector
 * @param {jquery} $el - DOM container for the relevant quantity
 * @return {jquery} - quantity selector DOM container
 */
function getQuantitySelector($el) {
    var quantitySelected;
    if ($el && $('.set-items').length) {
        quantitySelected = $($el).closest('.product-detail').find('.quantity-select');
    } else if ($el && $('.product-bundle').length) {
        var quantitySelectedModal = $($el).closest('.modal-footer').find('.quantity-select');
        var quantitySelectedPDP = $($el).closest('.bundle-footer').find('.quantity-select');
        if (quantitySelectedModal.val() === undefined) {
            quantitySelected = quantitySelectedPDP;
        } else {
            quantitySelected = quantitySelectedModal;
        }
    } else {
        quantitySelected = $('.quantity-select');
    }
    return quantitySelected;
}

/**
 * Updates the quantity DOM elements post Ajax call
 * @param {UpdatedQuantity[]} quantities -
 * @param {jQuery} $productContainer - DOM container for a given product
 */
function updateQuantities(quantities, $productContainer) {
    if ($productContainer.parent('.bonus-product-item').length <= 0) {
        var optionsHtml = quantities.map(function (quantity) {
            var selected = quantity.selected ? ' selected ' : '';
            return '<option value="' + quantity.value + '"  data-url="' + quantity.url + '"' +
                selected + '>' + quantity.value + '</option>';
        }).join('');
        getQuantitySelector($productContainer).empty().html(optionsHtml);
    }
}

/**
 * Parses the html for a modal window
 * @param {string} html - representing the body and footer of the modal window
 *
 * @return {Object} - Object with properties body and footer.
 */
function parseHtml(html) {
    var $html = $('<div>').append($.parseHTML(html));

    var body = $html.find('.choice-of-bonus-product');
    var footer = $html.find('.modal-footer').children();

    return { body: body, footer: footer };
}

/**
 * Retrieves url to use when adding a product to the cart
 *
 * @param {Object} data - data object used to fill in dynamic portions of the html
 */
function chooseBonusProducts(data) {
    $.spinner().start();

    if ($('#chooseBonusProductModal').length !== 0) {
        $('#chooseBonusProductModal').remove();
    }
    var bonusUrl;
    if (data.bonusChoiceRuleBased) {
        bonusUrl = data.showProductsUrlRuleBased;
    } else {
        bonusUrl = data.showProductsUrlListBased;
    }

    var htmlString = '<!-- Modal -->'
        + '<div class="modal fade" id="chooseBonusProductModal" tabindex="-1" role="dialog">'
        + '<span class="enter-message sr-only" ></span>'
        + '<div class="modal-dialog choose-bonus-product-dialog" '
        + 'data-total-qty="' + data.maxBonusItems + '"'
        + 'data-UUID="' + data.uuid + '"'
        + 'data-pliUUID="' + data.pliUUID + '"'
        + 'data-addToCartUrl="' + data.addToCartUrl + '"'
        + 'data-pageStart="0"'
        + 'data-pageSize="' + data.pageSize + '"'
        + 'data-moreURL="' + data.showProductsUrlRuleBased + '"'
        + 'data-bonusChoiceRuleBased="' + data.bonusChoiceRuleBased + '">'
        + '<!-- Modal content-->'
        + '<div class="modal-content">'
        + '<div class="modal-header">'
        + '    <span class="">' + data.labels.selectprods + '</span>'
        + '    <button type="button" class="close pull-right" data-dismiss="modal">'
        + '        <span aria-hidden="true">&times;</span>'
        + '        <span class="sr-only"> </span>'
        + '    </button>'
        + '</div>'
        + '<div class="modal-body"></div>'
        + '<div class="modal-footer"></div>'
        + '</div>'
        + '</div>'
        + '</div>';
    $('body').append(htmlString);
    $.spinner().start();

    $.ajax({
        url: bonusUrl,
        method: 'GET',
        dataType: 'json',
        success: function (response) {
            var parsedHtml = parseHtml(response.renderedTemplate);
            $('#chooseBonusProductModal .modal-body').empty();
            $('#chooseBonusProductModal .enter-message').text(response.enterDialogMessage);
            $('#chooseBonusProductModal .modal-header .close .sr-only').text(response.closeButtonText);
            $('#chooseBonusProductModal .modal-body').html(parsedHtml.body);
            $('#chooseBonusProductModal .modal-footer').html(parsedHtml.footer);
            $('#chooseBonusProductModal').modal('show');
            $.spinner().stop();
        },
        error: function () {
            $.spinner().stop();
        }
    });
}

/**
* updates the specification tab information on variant change.
* @param {Object} product - the Url for the selected variation value
* @param {jQuery} $productContainer - DOM element for current product
*/
function updateSpecificationTabInformation(product, $productContainer) {
    if (product.attributes && product.attributes.length) {
        var htmlSnippet = '';
        $productContainer.find('.js-specification-block .attribute-group').html('');
        product.attributes.forEach(function (attrGroup) {
            if (attrGroup.ID !== 'mainAttributes' && attrGroup.ID !== 'Variation Attributes') {
                htmlSnippet = '<ul id="' + attrGroup.ID + '">'
                + '<li class="attributes">'
                + '<div class="row">'
                + '<div class="col-5"><span class="attr-label">Item #</span></div>'
                + '<div class="col-7"><div class="attr-value">' + product.id + '</div></div>'
                + '</div>'
                + '</li>';

                attrGroup.attributes.forEach(function (attr) {
                    if (attr.label !== 'Customize Enable' && attr.label !== 'Prop 65 Message') {
                        htmlSnippet += '<li class="attributes">'
                        + '<div class="row">'
                        + '<div class="col-5">'
                        + '<span class="attr-label">' + attr.label + ':</span>'
                        + '</div>'
                        + '<div class="col-7">';

                        attr.value.forEach(function (value) {
                            htmlSnippet += `<div class="attr-value">${value}</div>`;
                        });

                        htmlSnippet += '</div></div></li>';
                    }
                });
                htmlSnippet += '</ul>';
                htmlSnippet += product.prop65WarningHtml || '';
            }
            $productContainer.find('.js-specification-block .attribute-group').append(htmlSnippet);
        });
    }
}

/**
 * updates the product view when a product attribute is selected or deselected or when
 *         changing quantity
 * @param {string} selectedValueUrl - the Url for the selected variation value
 * @param {jQuery} $productContainer - DOM element for current product
 */
function attributeSelect(selectedValueUrl, $productContainer) {
    if (selectedValueUrl) {
        $('body').trigger('product:beforeAttributeSelect',
            { url: selectedValueUrl, container: $productContainer });

        $.ajax({
            url: selectedValueUrl,
            method: 'GET',
            success: function (data) {
                handleVariantResponse(data, $productContainer);
                updateOptions(data.product.optionsHtml, $productContainer);
                updateQuantities(data.product.quantities, $productContainer);
                updateSpecificationTabInformation(data.product, $productContainer);
                $('body').trigger('product:afterAttributeSelect',
                    { data: data, container: $productContainer });
                $.spinner().stop();
                if (data.product.variant && window.dataLayer) {
                    var variantData = {
                        id: data.product.id,
                        variant: data.product.variantProductSKU || data.product.id,
                        variantProductSKU: data.product.variantProductSKU,
                        masterProductSKU: data.product.masterProductSKU,
                        name: data.product.productName,
                        isVariant: true
                    };
                    if (data.product.price && data.product.price.sales) {
                        variantData.price = data.product.price.sales.value.toFixed(2);
                    }
                    for (var i = 0; i < window.dataLayer.length; i++) {
                        if (window.dataLayer[i] && window.dataLayer[i].pageType && window.dataLayer[i].pageType.includes('Product Page')) {
                            var prod = window.dataLayer[i].ecommerce.detail.products[0];
                            Object.keys(variantData).forEach(function (key) { prod[key] = variantData[key]; });
                            break;
                        }
                    }
                    window.dataLayer.push({
                        event: 'productVariantSelected',
                        ecommerce: {
                            detail: {
                                products: [variantData]
                            }
                        }
                    });
                }
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Displays sucess of adding PLI to cart.
 * @param {string} pliUUID - The PLI UUID.
*/
function addToCartModal(pliUUID) {
    // Success - show modal.
    var addToCartModalUrl = $('.product-detail').data('atc-modal');
    if (addToCartModalUrl) {
        $.ajax({
            url: addToCartModalUrl,
            method: 'GET',
            data: { pliUUID: pliUUID },
            success: function (data) {
                $.spinner().stop();
                $('#addToCartModal').remove();
                $('body').append(data);
                $('#addToCartModal').modal('show');
                setTimeout(function () {
                    $("#addToCartModal .modal-dialog").trigger('focus'); // Focus the modal dialog for accessibility
                    carousels.addedToCartRecommendations();
                }, 500);
            },
            error: function () {
                $.spinner().stop();
            }
        });
    }
}

/**
 * Includes Custom Form Elements into the Add To Cart Call.
 * @param {Object} formObj - The Object representing the form values.
*/
function customAttributes(formObj) {
    var fields = [
        'engraving-text-style',
        'text-to-display',
        'text-to-display-line-2',
        'text-to-display-line-3',
        'text-to-display-line-4',
        'embroidered-text-color',
        'embroidered-text-style',
        'flag',
        'lace-color',
        'custom-type',
        'gc-recipient-name',
        'gc-recipient-email',
        'gc-from-name',
        'gc-text-message'
    ];
    var $field;
    for (var i = 0; i < fields.length; i++) {
        $field = $('input[name="' + fields[i] + '"], textarea[name="' + fields[i] + '"]');
        if ($field.length) {
            formObj[fields[i]] = $field.val();
        }
    }
}

/**
 * Updates the Mini-Cart quantity value after the customer has pressed the "Add to Cart" button
 * @param {string} response - ajax response from clicking the add to cart button
*/
function handlePostCartAdd(response) {
    $('.minicart').trigger('count:update', response);
    var messageType = response.error ? 'alert-danger' : 'alert-success';
    if (response.error) {
        $.spinner().stop();
    }

    // show add to cart toast
    if (response.newBonusDiscountLineItem && Object.keys(response.newBonusDiscountLineItem).length !== 0) {
        chooseBonusProducts(response.newBonusDiscountLineItem);
        return;
    }

    // Otherwise, we have a success, or failure.
    if (messageType === 'alert-danger') {
        if ($('.add-to-cart-messages').length === 0) {
            $('body').append(
                '<div class="add-to-cart-messages"></div>'
            );
        }

        $('.add-to-cart-messages').append(
            '<div class="alert ' + messageType + ' add-to-basket-alert text-center" role="alert">'
            + response.message
            + '</div>'
        );

        setTimeout(function () {
            $('.add-to-basket-alert').remove();
        }, 5000);
    } else {
        $.spinner().start();
        addToCartModal(response.pliUUID);
    }
}

/**
 * Init the product carousel using a predefined slick configuration
 * @param {string} initialSlide - set initial number of initial slide
*/
function carouselInit(initialSlide) {
    var setInitialSlide = initialSlide || 0;
    var $carousel = $('.product-carousel');
    var $carouselContainer;

    if ($carousel.length) {
        var defaultConfig = slickConfigs.pdp;

        defaultConfig.initialSlide = setInitialSlide;

        $carouselContainer = $carousel.parents('.primary-images-carousel');
        imagesloaded($carousel).on('done', function () {
            if ($carousel.hasClass('slick-initialized')) {
                $carousel.slick('unslick');
            }
            $carousel.not('.slick-initialized').slick(defaultConfig);
            $carouselContainer.toggle();
            $('html').addClass('overflow');
        });
    }
}

lyonscg.colorAttribute = function () {
    $(document).on('click', '[data-attr="color"] button', function (e) {
        e.preventDefault();

        var $productContainer = $(this).closest('.set-item');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.product-detail');
        }

        attributeSelect($(this).attr('data-url'), $productContainer);
    });
};

lyonscg.selectAttribute = function () {
    $(document).on('change', 'select[class*="select-"], .options-select', function (e) {
        e.preventDefault();

        var $productContainer = $(this).closest('.set-item');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.product-detail');
        }
        console.log(e.currentTarget);
        attributeSelect(e.currentTarget.value, $productContainer);
    });
};

lyonscg.availability = function () {
    $(document).on('change', '.quantity-select', function (e) {
        e.preventDefault();

        var $productContainer = $(this).closest('.product-detail');
        if (!$productContainer.length) {
            $productContainer = $(this).closest('.modal-content').find('.product-quickview');
        }

        if ($('.bundle-items', $productContainer).length === 0) {
            attributeSelect($(e.currentTarget).find('option:selected').data('url'),
                $productContainer);
        }
    });
};

var exportBase = $.extend({}, lyonscg, {
    attributeSelect: attributeSelect,
    colorAttribute: lyonscg.colorAttribute,
    selectAttribute: lyonscg.selectAttribute,
    availability: lyonscg.availability,

    updateMainImages: function (product) {
        var images = product.images;
        var productID = product.id;
        var imagesZoom = product.imagesZoom['hi-res'];
        var htmlString = '<!-- Product Image slides -->';
        var gridString = '<!-- Product Image grid -->';
        var mobileCarouselString = '<!-- Product Mobile Image slides -->';
        var mobileIndicatorsString = '<!-- Product Mobile Image indicators -->';
        var isBonusProduct = false;
        var cbpCount = $('.choice-of-bonus-product').length;

        if (cbpCount > 0) {
            if (product.productType === 'variant') {
                var prodUrl = product.selectedProductUrl.split('?')[0];
                prodUrl = prodUrl.substring(prodUrl.indexOf('/product/') + 1);
                productID = prodUrl.replace('product/', '').replace('.html', '');
            }

            isBonusProduct = $('#pdpCarousel-' + productID).parents('.choice-of-bonus-product').length > 0;

            if (isBonusProduct) {
                images.large.length = 1;
            }
        }

        images.large.forEach(function (image, idx) {
            var zoomImage = imagesZoom[idx] ? imagesZoom[idx] : image;
            var zoomClass = imagesZoom[idx] ? 'zoom-hires' : 'zoom-disabled';
            var htmlSlide = '<div class="slide">'
                + '<div class="slide-link ' + zoomClass + '" title="' + zoomImage.title + '">'
                    + '<img src="' + image.url + '" class="slide-img" alt="' + image.alt + '" />'
                + '</div>'
            + '</div>';
            var gridSlide = '';

            gridSlide += '<a class="image-grid image-container-wrapper" href="' + image.url + '" title='
            + zoomImage.title + '" data-position="' + idx + '">'
            + '<div class="image-grid-image image-container" data-current-item="'
            + idx + '"><div class="grid-image">'
            + '<img src="' + image.url + '" class="tile-img" alt="' + image.alt + '" />'
            + '</div></div></a>';

            var mobileCarouselSlide = '<div class="mobile-main-carousel-item"><img src="' + image.url + '"'
            + 'class="d-block img-fluid" alt="${image.alt} image number ' + idx + '" itemprop="image" /></div>';
            htmlString += htmlSlide;
            gridString += gridSlide;
            mobileCarouselString += mobileCarouselSlide;
        });

        images.small.forEach(function (image, idx) {
            var mobileIndicatorsSlide = '<div class="mobile-carousel-indicators-item"><img src="' + image.url + '"'
            + 'class="d-block img-fluid" alt="${image.alt} image number ' + idx + '" itemprop="image" /></div>';
            mobileIndicatorsString += mobileIndicatorsSlide;
        });

        var $varName = $('.product-detail .set-items');
        var $carouselImage;
        var $tempDiv;
        var $grid = $('.primary-images-desktop-view .primary-images-carousel-wrapper');
        var $mobileCarousel = $('.primary-images-mobile-view .mobile-main-carousel');
        var $mobileIndicators = $('.primary-images-mobile-view .mobile-carousel-indicators');
        var arrowShow = true;

        $mobileCarousel.slick('unslick');
        $mobileIndicators.slick('unslick');
        if ($varName.length) {
            $tempDiv = $('div.set-items').find('div[data-pid="' + productID + '"]');
            $carouselImage = $tempDiv.find('.product-carousel');
        } else if (cbpCount > 0 && $('.product-carousel').length > 1) {
            $carouselImage = $('#pdpCarousel-' + productID + '.product-carousel');
        } else {
            $carouselImage = $('.product-carousel');
        }

        $carouselImage.html(htmlString);
        $mobileCarousel.empty();
        if (!isBonusProduct) {
            $grid.empty();
            $grid.html(gridString);
        }
        // if (!document.querySelector('.pd-product-detail')) { $('html,body').animate({ scrollTop: $('#maincontent').offset().top }, 400); }

        $mobileCarousel.html(mobileCarouselString).not('.slick-initialized').slick({
            slidesToShow: 1,
            slidesToScroll: 1,
            arrows: arrowShow,
            dots: true,
            fade: false,
            infinite: false,
            appendDots: $mobileCarousel.parent('.primary-images').find('.slick-nav'),
            prevArrow: $mobileCarousel.parent('.primary-images').find('.prevArrow'),
            nextArrow: $mobileCarousel.parent('.primary-images').find('.nextArrow')
        });
        $mobileIndicators.html(mobileIndicatorsString).not('.slick-initialized').slick(slickConfigs.pdpMobilenNav);
        $('.mobile-carousel-indicators .slick-slide').removeClass('slick-active');
        $('.mobile-carousel-indicators .slick-slide').eq(0).addClass('slick-active');
        // If There's only one slide, hide the arrows
        // Probably a better way to do this but slick will never have it natively
        if ($('.mobile-main-carousel.slick-initialized').find('.slick-slide:not(.slick-cloned)').length < 2) {
            $('.slider-controls').hide();
        }
    },
    addToCart: function () {
        $(document).on('click', 'button.add-to-cart, button.add-to-cart-global', function () {
            var $target = $(this);
            var addToCartUrl;
            var pid;
            var pidsObj;
            var setPids;

            $('body').trigger('product:beforeAddToCart', this);

            if ($('.set-items').length && $target.hasClass('add-to-cart-global')) {
                setPids = [];

                $('.product-detail').each(function () {
                    if (!$target.hasClass('product-set-detail')) {
                        setPids.push({
                            pid: $target.find('.product-id').text(),
                            qty: $target.find('.quantity-select').val(),
                            options: lyonscg.getOptions($target)
                        });
                    }
                });
                pidsObj = JSON.stringify(setPids);
            }

            pid = lyonscg.getPidValue($target);

            var $productContainer = $target.closest('.product-detail');
            if (!$productContainer.length) {
                $productContainer = $target.closest('.quick-view-dialog').find('.product-detail');
            }

            addToCartUrl = $('.add-to-cart-url').val();

            var form = {
                pid: pid,
                pidsObj: pidsObj,
                childProducts: lyonscg.getChildProducts(),
                quantity: lyonscg.getQuantitySelected($target)
            };

            // Take the customized Products into account:
            customAttributes(form);

            if ($('.giftcard-fields')) {
                form.giftCardAmount = $('select.select-giftCardAmount option:selected').attr('data-attr-value');
                form.giftCardType = $('select.select-giftCardType option:selected').attr('data-attr-value');
            }

            if (!$('.bundle-item').length) {
                form.options = lyonscg.getOptions($productContainer);
            }

            $target.trigger('updateAddToCartFormData', form);
            if (addToCartUrl) {
                $.ajax({
                    url: addToCartUrl,
                    method: 'POST',
                    data: form,
                    success: function (data) {
                        handlePostCartAdd(data);
                        $('body').trigger('product:afterAddToCart', data);
                        lyonscg.miniCartReportingUrl(data.reportingURL);
                    },
                    error: function () {
                        $.spinner().stop();
                    }
                });
            }
        });
    },
    carouselInit: carouselInit,
    initMobileCarousel: function () {
        var $mainCarousel = $('.mobile-main-carousel');
        var $navCarousel = $('.mobile-carousel-indicators');

        if ($mainCarousel.length) {
            imagesloaded($mainCarousel).on('done', function () {
                if ($mainCarousel.hasClass('slick-initialized')) {
                    $mainCarousel.slick('unslick');
                }
                $mainCarousel.not('.slick-initialized').slick({
                    slidesToShow: 1,
                    slidesToScroll: 1,
                    arrows: true,
                    dots: true,
                    fade: false,
                    infinite: false,
                    appendDots: $mainCarousel.parent('.primary-images').find('.slick-nav'),
                    prevArrow: $mainCarousel.parent('.primary-images').find('.prevArrow'),
                    nextArrow: $mainCarousel.parent('.primary-images').find('.nextArrow')
                });
                $navCarousel.not('.slick-initialized').slick(slickConfigs.pdpMobilenNav);
                $('.mobile-carousel-indicators .slick-slide').removeClass('slick-active');
                $('.mobile-carousel-indicators .slick-slide').eq(0).addClass('slick-active');

                // If There's only one slide, hide the arrows
                // Probably a better way to do this but slick will never have it natively
                if ($('.mobile-main-carousel.slick-initialized').find('.slick-slide:not(.slick-cloned)').length < 2) {
                    $('.slider-controls').hide();
                }

                // Setup the carousel of thumbnails near the main image
                $navCarousel.on('init', function () {
                    $('.product-thumbnails .carousel .slick-slide.slick-current').addClass('is-active');
                });

                $mainCarousel.on('afterChange', function (event, slick, currentSlide) {
                    var $thumbSlide = $navCarousel.find('.slick-slide').eq(currentSlide);
                    var currentNavSlideElem = '.mobile-carousel-indicators .slick-slide[data-slick-index="' + currentSlide + '"]';
                    $navCarousel.find('.slick-slide').removeClass('slick-current');
                    $thumbSlide.addClass('slick-current');
                    $navCarousel.slick('slickGoTo', currentSlide);

                    $('.mobile-carousel-indicators .slick-slide.slick-active').removeClass('slick-active');
                    $(currentNavSlideElem).addClass('slick-active');

                    if (!$thumbSlide.hasClass('slick-active')) {
                        $thumbSlide.trigger('click');
                    }
                });

                $navCarousel.on('click', '.slick-slide', function (event) {
                    if ($(this).data('slick-index') === 0) {
                        $('.mobile-carousel-indicators .slick-slide').removeClass('slick-active');
                        $('.mobile-carousel-indicators .slick-slide').eq(0).addClass('slick-active');
                    }

                    event.preventDefault();
                    var goToSingleSlide = $(this).data('slick-index');
                    $mainCarousel.slick('slickGoTo', goToSingleSlide);
                });
            });
        }
    }
});

window.onload = function () {
    var priceValueClass = $('.prices-add-to-cart-actions .price .carttotal');
    if (priceValueClass.length > 0 && priceValueClass.val() !== null && priceValueClass !== '') {
        var priceValue = priceValueClass.val();
        var emiVal = priceValue / 4;
        $('.emi-price').text(emiVal.toFixed(2));
    }
};

module.exports = exportBase;
